import { LegalShell } from "./LegalShell";

export default function Privacidad() {
  return (
    <LegalShell eyebrow="/ LFPDPPP" title="Aviso de privacidad" updated="19 de agosto de 2026">
      <h2>Identidad y domicilio del responsable</h2>
      <p>
        El presente Aviso de Privacidad se emite en cumplimiento de la Ley Federal de Protección de
        Datos Personales en Posesión de los Particulares (LFPDPPP) y su reglamento.
      </p>
      <p>
        <strong>MARKETING DE INTELIGENCIA ARTIFICIAL S. de R.L. de C.V.</strong>, con domicilio en
        Av. Américas 1545, Colonia Providencia, Guadalajara, Jalisco, México, teléfono
        <a href="tel:+523342802102"> 33 4280 2102</a>, es la responsable del tratamiento de tus datos
        personales. El <strong>responsable operativo</strong> es el <strong>Sr. Ricardo Zermeño Mejía</strong>.
      </p>

      <h2>Datos personales que recabamos</h2>
      <ul>
        <li>De identificación: nombre del dueño y de los empleados que operan la caja.</li>
        <li>De contacto: teléfono celular del negocio.</li>
        <li>Del negocio: nombre comercial, giro, domicilio si lo proporcionas, inventario y catálogo de productos.</li>
        <li>De operación: ventas, tickets, cuentas de fiado y comandos de voz procesados para brindar el servicio.</li>
        <li>De pago: referencia bancaria, monto y fecha del depósito o transferencia. <em>No almacenamos tus credenciales bancarias en ningún momento.</em></li>
      </ul>

      <h2>Datos sensibles</h2>
      <p>
        <strong>No recabamos datos personales sensibles</strong> tal y como los define el artículo 3
        fracción VI de la LFPDPPP.
      </p>

      <h2>Finalidades del tratamiento</h2>
      <p><strong>Finalidades primarias (necesarias):</strong></p>
      <ul>
        <li>Prestarte el servicio de punto de venta CHALANN.</li>
        <li>Procesar tus comandos de voz para reconocer productos y cantidades.</li>
        <li>Emitir recibos digitales para tus clientes.</li>
        <li>Registrar y conciliar tus pagos mensuales.</li>
        <li>Contactarte para dudas, soporte o cobranza.</li>
        <li>Cumplir obligaciones fiscales y legales aplicables.</li>
      </ul>
      <p><strong>Finalidades secundarias (opcionales):</strong></p>
      <ul>
        <li>Enviarte comunicaciones sobre nuevas funciones, promociones y noticias del producto.</li>
        <li>Elaborar estadísticas de uso agregadas y anonimizadas para mejorar el servicio.</li>
      </ul>
      <p>
        Si no deseas que tus datos se utilicen para las finalidades secundarias, puedes notificarlo al
        correo o teléfono de contacto y las suspenderemos, sin que esto afecte el servicio principal.
      </p>

      <h2>Transferencias de datos</h2>
      <p>
        No transferimos tus datos personales a terceros salvo en los siguientes casos: (i) a
        proveedores de infraestructura tecnológica que actúan como encargados bajo obligación de
        confidencialidad; (ii) cuando exista requerimiento fundado y motivado de autoridad competente;
        (iii) cuando sea necesario para el cumplimiento de obligaciones fiscales.
      </p>

      <h2>Derechos ARCO y revocación del consentimiento</h2>
      <p>
        Tienes derecho a <strong>acceder, rectificar, cancelar u oponerte</strong> al tratamiento de tus
        datos personales (Derechos ARCO), así como a revocar el consentimiento otorgado. Para ejercer
        cualquiera de estos derechos, envíanos tu solicitud al teléfono <a href="tel:+523342802102">33 4280 2102</a>
        indicando tu nombre, número de negocio o CLABE de referencia, el derecho que deseas ejercer y
        una descripción clara y precisa. Atenderemos tu solicitud en un plazo máximo de 20 días hábiles.
      </p>

      <h2>Conservación de datos</h2>
      <p>
        Conservaremos tus datos mientras exista una relación de servicio con nosotros y por los plazos
        adicionales que la legislación fiscal y mercantil aplicable exija. Cumplido ese plazo, los datos
        serán eliminados o anonimizados de manera segura.
      </p>

      <h2>Uso de tecnologías de rastreo</h2>
      <p>
        La plataforma utiliza almacenamiento local del navegador (localStorage) para mantener tu sesión
        y preferencias, así como cookies estrictamente necesarias para el funcionamiento del servicio.
        No usamos cookies publicitarias de terceros.
      </p>

      <h2>Modificaciones al Aviso de Privacidad</h2>
      <p>
        El presente Aviso podrá modificarse en cualquier momento; publicaremos la versión vigente en
        esta misma dirección. El uso continuo del servicio después de una modificación implica el
        conocimiento y aceptación de la misma.
      </p>

      <p className="mt-8 not-prose text-sm text-neutral-600">
        Responsable del tratamiento: <strong>Ricardo Zermeño Mejía</strong>.
      </p>
    </LegalShell>
  );
}
